import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24px",
  height: "24px",
  version: "1.1",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("ellipse", {
      stroke: "#868686",
      cx: "12",
      cy: "12",
      rx: "9.45",
      ry: "9.45",
      style: {"fill":"none","stroke-width":"1"}
    }, null, -1)
  ]))]))
}
export default { render: render }